import React from 'react';

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  children: React.ReactNode;
}

// min-h-11/min-w-11 == 44px, the WCAG 2.5.5 target size.
const IconButton: React.FC<IconButtonProps> = ({ label, children, className = '', ...rest }) => (
  <button
    type="button"
    aria-label={label}
    title={label}
    className={`inline-flex min-h-11 min-w-11 items-center justify-center rounded-xl bg-surface-raised text-content hover:bg-surface-sunken transition-colors ${className}`}
    {...rest}
  >
    {children}
  </button>
);

export default IconButton;
